import {IPagedResult} from '../common/PagedResult';
import {Paging} from '../common/Paging';
import {ElasticUserPersonModel} from './ElasticUserPersonModel';

export class ElasticUserResultPaged implements IPagedResult<ElasticUserPersonModel> {
  paging?: Paging | undefined;
  result?: ElasticUserPersonModel[] | undefined;

  constructor(data?: IPagedResult<ElasticUserPersonModel>) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(Data?: any) {
    if (Data) {
      this.paging = Data["paging"] ? Paging.fromJS(Data["paging"]) : <any>undefined;
      if (Array.isArray(Data["result"])) {
        this.result = [] as any;
        for (let item of Data["result"])
          this.result!.push(ElasticUserPersonModel.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ElasticUserResultPaged {
    data = typeof data === 'object' ? data : {};
    let result = new ElasticUserResultPaged();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["paging"] = this.paging ? this.paging.toJSON() : <any>undefined;
    if (Array.isArray(this.result)) {
      data["result"] = [];
      for (let item of this.result)
        data["result"].push(item.toJSON());
    }
    return data;
  }
}
